import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { CATEGORY_LABELS, type TicketSummary } from '../lib/api';
import { formatRelative } from '../lib/format';
import { StatusPill } from './StatusPill';

export function TicketRow({ ticket }: { ticket: TicketSummary }) {
  return (
    <Link
      to={`/tickets/${ticket.id}`}
      className="group flex items-center gap-3 py-4 min-h-[56px] border-b border-line last:border-b-0 transition-colors hover:bg-surface-muted active:bg-surface-muted -mx-1 px-1 rounded-lg"
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[13px] text-ink-muted">#{ticket.id}</span>
          <StatusPill status={ticket.status} />
        </div>
        <p className="text-[14px] text-ink font-medium truncate">
          {ticket.subject ?? CATEGORY_LABELS[ticket.category]}
        </p>
        <p className="text-[12px] text-ink-muted mt-0.5">
          {CATEGORY_LABELS[ticket.category]} · {formatRelative(ticket.updated_at)}
        </p>
      </div>
      <ChevronRight
        size={18}
        className="shrink-0 text-ink-faint transition-colors group-hover:text-ink-muted"
      />
    </Link>
  );
}
